export default "__VITE_ASSET__fdcd1c6d__"